import PhotoSwipeLightbox from "photoswipe/dist/photoswipe-lightbox.esm.js";
import PhotoSwipe from "photoswipe/dist/photoswipe.esm.js";
const svgIcons = require("../../../../config/inlinesvg.json");
const $zoomModal = $("#zoomModal");
const $document = $(document);
const $window = $(window);

/**
 * @function
 * @description - Update zoom modal if window is bigger than image height of 1600px
 */
const resizeZoomModal = () => {
    $zoomModal.removeClass("resized");
    const windowHeight = $(window).height();
    $zoomModal.toggleClass("resized", windowHeight >= 1600);
};

/**
 * @function
 * @description - Select active thumbnail for zoom modal
 * @param {Object} selectedItem element which is selected
 */
const selectThumbnail = (selectedItem) => {
    const $thumbnails= $(".pdp-thumbnail.selected");

    $thumbnails.removeClass("selected");
    $thumbnails.parents(".js-trigger-photo-swipe-thumbnail").attr("aria-current", false);

    selectedItem.addClass("selected");
    selectedItem.parents(".js-trigger-photo-swipe-thumbnail").attr("aria-current", true);
};

/**
 * @function
 * @description - Update zoomed image url after selecting new image
 * @param {Object} selectedItem element which is selected
 */
const updateImgUrl = img => {
    $("#imageZoom").attr("src", $(img).data("original-img"));
    $(".containerZoom")
        .css({
            "background-image": "url(" + $("#imageZoom").attr("src") + ")",
            "background-position": "50% 50%"
        });
};

/**
 * @function
 * @description - Open modal window with zoom image
 * @param {String} type type of modal
 */
const openModal = (type) => {
    $(".product-detail").on("click", ".pdp-carousel-img", (e) => {
        selectThumbnail($("[data-thumbnail-index=" + $(e.target).data("original-img-index") + "]"));

        if (type === "zoom") {
            $zoomModal.spinner().start();
            updateImgUrl(e.target);
            $zoomModal.modal("show");
        }
    });

    // handel the enter key when the a tag is in focus
    $(".product-detail").on("keydown", ".js-trigger-photo-swipe", (e) => {
        if (e.type === "keydown" && e.key === "Enter") {
            $(e.target).find(".pdp-carousel-img").trigger("click");
        }
    });

    // handle the thumbnails enter key when the a tag is in focus
    $(".product-detail").on("keydown", ".js-trigger-photo-swipe-thumbnail", (e) => {
        if (e.type === "keydown" && e.key === "Enter") {
            $(e.target).find(".pdp-thumbnail").trigger("click");
        }
    });

    initImageZoomKeyPositionin();
    initZoomFocusTrap();
};

/**
 * @function
 * @description - Init events for zoom image
 */
const initZoomEvents = () => {
    if (!$("#imageZoom").parent().is(".containerZoom")) {
        $("#imageZoom").imageZoom();
    }

    $zoomModal.on("shown.bs.modal", () => {
        if (!$("#imageZoom").hasClass("active-zoom")) {
            try {
                $("#imageZoom").addClass("active-zoom").trigger("click");
            } catch {
                return; // ignore errors from image-zoom-min.js file
            }
        }
    });

    openModal("zoom");

    $document.on("click", ".active-zoom", () => {
        $zoomModal.modal("hide");
        $("#imageZoom").removeClass("active-zoom");
    });

    $zoomModal.on("click", ".pdp-thumbnail", (e) => {
        $zoomModal.spinner().start();
        updateImgUrl(e.target);
        $("#imageZoom").addClass("active-zoom");
        selectThumbnail($(e.target));
    });

    $("#imageZoom").on("load", function () {
        $zoomModal.spinner().stop();
    });
};


/**
 * @function
 * @description - Init events for swiping zoom image
 */
const initPhotoSwipe = () => {
    const $triggerSwipe = $(".trigger-photo-swipe");
    const iconClose = svgIcons.close;

    if ($window.width() >= 544) {
        $triggerSwipe.attr("data-pswp-width", 1000);
        $triggerSwipe.attr("data-pswp-height", 1333);
    }

    const lightbox = new PhotoSwipeLightbox({
        gallery: ".trigger-photo-swipe",
        initialZoomLevel: 1,
        closeSVG: iconClose,
        pinchToClose: false,
        pswpModule: PhotoSwipe
    });

    lightbox.on("uiRegister", function() {
        lightbox.pswp.ui.registerElement({
            html: $(".thumbnails-wrapper").html(),
            onInit: function(el) {
                el.classList.add("thumbnails-wrapper");
            }
        });
    });

    lightbox.init();

    openModal("swipe");

    $document.on("click", ".thumbnails-wrapper .trigger-photo-swipe", (e) => {
        const $el = $(e.target);

        $(".pswp__img").attr("src", $el.data("zoom-sm"));
        selectThumbnail($el);
    });
};

/**
 * @function
 * @description - Init zoom depending on breakpoint
 */
const initZoom = () => {
    if ($window.width() > 769) {
        initZoomEvents();
    } else {
        initPhotoSwipe();
    }
};

/**
* Initializes keyboard navigation for image zoom functionality by adjusting the background position
* of a container element using arrow keys. The position is adjusted in increments defined by the
* step value, ensuring the position remains within the bounds of 0% to 100%.
*
* @function
* @description This function binds a keydown event listener to the document, which listens for
* arrow key presses to adjust the background position of elements with the class "containerZoom".
* The background position is modified to simulate zoom navigation, allowing users to move the
* zoomed image within the container.
*
* @example
* // Call this function to enable image zoom navigation via keyboard
* initImageZoomKeyPositionin();
*
* @listens document#keydown
*/
const initImageZoomKeyPositionin = () => {
    const step = 5; // Adjust this value for sensitivity

    $document.on("keydown", function(e) {
        const container = $(".containerZoom");
        if (container.length === 0) return;

        // Get current background position
        const bgPos = container.css("background-position").split(" ");
        let xPos = parseFloat(bgPos[0]);
        let yPos = parseFloat(bgPos[1]);

        // Adjust position based on arrow key pressed
        switch (e.key) {
            case "ArrowUp":
                yPos = Math.max(0, yPos - step);
                break;
            case "ArrowDown":
                yPos = Math.min(100, yPos + step);
                break;
            case "ArrowLeft":
                xPos = Math.max(0, xPos - step);
                break;
            case "ArrowRight":
                xPos = Math.min(100, xPos + step);
                break;
            default:
                return; // Exit if it"s not an arrow key
        }

        // Update the background position
        container.css("background-position", `${xPos}% ${yPos}%`);
    });
};

/**
* Initializes a focus trap within a zoom modal to ensure keyboard navigation
* cycles through focusable elements. This function sets up event listeners
* to manage focus when the Tab or Shift+Tab keys are pressed, preventing
* focus from escaping the modal.
*
* @function
* @description This function identifies the first and last focusable elements
* within the zoom modal and sets up a keydown event listener to trap focus
* within these elements. When the Tab key is pressed, focus will cycle from
* the last to the first element, and vice versa when Shift+Tab is pressed.
*/
let triggerElement; // Variable to store the element that opened the modal

const initZoomFocusTrap = () => {
    const focusableElements = "a[href]:visible, button, [tabindex='0']:visible";
    const focusableItems = $zoomModal.find(focusableElements);
    const firstFocusableElement = $zoomModal.find(focusableElements).first();
    const lastFocusableElement = $zoomModal.find(focusableElements).last();

    $zoomModal.on("keydown", function(e) {
        const isTabPressed = (e.key === "Tab" || e.keyCode === 9);

        if (!isTabPressed) {
            return;
        }

        if (focusableItems.length === 0) {
            // If there are no focusable elements, prevent tabbing away and focus the zoom modal close button
            e.preventDefault();
            $zoomModal.find("[data-dismiss='modal']").focus();
            return;
        }

        if (e.shiftKey) { // If Shift + Tab
            if ($(document.activeElement).is(firstFocusableElement)) {
                lastFocusableElement.focus();
                e.preventDefault();
            }
        } else { // If Tab
            if ($(document.activeElement).is(lastFocusableElement)) {
                firstFocusableElement.focus();
                e.preventDefault();
            }
        }
    });

    // Event listener for opening the modal
    $(".js-trigger-photo-swipe:visible").on("click", function() {
        triggerElement = this; // Store the element that triggered the modal
    });

    // Event listener for closing the modal
    $zoomModal.on("hidden.bs.modal", function() {
        if (triggerElement) {
            triggerElement.focus(); // Return focus to the triggering element
        }
    });
};

export default function () {
    initZoom();

    $window.on("resize", () => {
        if ($window.width() <= 769) {
            initZoom();
        } else {
            resizeZoomModal();
        }
    });

    $("body").on("product:afterAttributeSelect", () => {
        if ($window.width() <= 769) {
            initPhotoSwipe();
        }
    });
}
